var locations_filtered

var map;
window.gm_markers = [];

function initMap() {
    if(!document.getElementById('map')){
        return;
    }

    locations_filtered = stores;
    var zoom = 7;
    var center = new google.maps.LatLng(52.4319571,5.1208176);

    if(window.userInfo && window.userInfo.country && window.userInfo.country.iso_code){
        switch (window.userInfo.country.iso_code){
            case "NL":
            case "BE":
            case "DE":
                zoom = 7;
                center = new google.maps.LatLng(52.4319571,5.1208176);
                break;
            case "US":
            case "UM":
            case "VI":
                zoom = 4;
                center = new google.maps.LatLng(37.0902,-95.7129);
                break;
            default:
                zoom = 2;
                center = new google.maps.LatLng(52.4319571,-37.1208176);
        }
    }


    // // nl
    // var zoom = 7;
    // var center = new google.maps.LatLng(52.4319571,5.1208176);

    // // world
    // var zoom = 2;
    // var center = new google.maps.LatLng(52.4319571,-37.1208176);
    //
    // // usa
    // var zoom = 4;
    // var center = new google.maps.LatLng(37.0902,-95.7129);


    var mapOptions = {
        zoom: zoom,
        center: center,
        scrollwheel: false,
        gestureHandling: 'cooperative',
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: true,

        //styles: [{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"hue":"#ff00e7"}]},{"featureType":"landscape.natural","elementType":"all","stylers":[{"visibility":"simplified"},{"lightness":"31"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#7fbebe"}]}]
    };

    map = new google.maps.Map(document.getElementById('map'), mapOptions);

    setMarkers(locations_filtered, map);
    // setMapFilters(map);

    // zoomOnMarkers(map, window.gm_markers);



    //searchbox();
};
initMap();

function setMarkers(markers, map){
    var infowindow;



    //create all markers
    markers.forEach(function (location, index, array) {
        var image = window.template_directory_uri + '/assets/img/pointer.svg';

        var myLatLng = new google.maps.LatLng(location.latitude,location.longitude);

        var myMarker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: image
        });

        // window.gm_markers.push(myMarker);

        window.gm_markers[location.ID] = myMarker;

        myMarker.addListener('click', function() {
            var state = 'desktop';
            var mobileWidth = 780;
            if(window.innerWidth < mobileWidth){
                state = 'mobile';
            }


            if(state == 'desktop'){
                $('ul.stores li').removeClass('active');
                var item = $('ul.stores li[data-id="'+location.ID+'"]');
                item.addClass('active');

                // element_position - padding + current_scroll
                var scrollTo = item.position().top - 40 + $('ul.stores').scrollTop();

                TweenMax.to( $('ul.stores'), 1, {scrollTo: {y: scrollTo, autoKill:false}});
            }else{
                $('ul.stores li').removeClass('active');
                var item = $('ul.stores li[data-id="'+location.ID+'"]');
                item.addClass('active');

                // if(infowindow)
                //     infowindow.close(map);
                //
                // var contentString = '<div id="content">'+
                //     '<div class="overlay">'+
                //     '<h2>' + location.name + '</h2>';
                //
                // contentString += '<a href="'+location.url+'" class="btn btn-green">more info</a>';
                // contentString += '</div>';
                // contentString += '</div>';
                //
                // infowindow = new google.maps.InfoWindow({
                //     content: contentString,
                //     maxWidth: 320
                // });
                // infowindow.setZIndex(1);
                //
                // infowindow.open(map, myMarker);
            }


        });
    });
}

function zoomOnMarkers(map, markers){
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
        bounds.extend( markers[i].getPosition() );
    }

    // add padding
    bounds.b.b = bounds.b.b - 0.1;
    bounds.b.f = bounds.b.f + 0.1;

    bounds.f.b = bounds.f.b - 0.1;
    bounds.f.f = bounds.f.f + 0.1;


    map.fitBounds(bounds);

}

function zoomOnMarkerWithID(id) {
    console.log(id);
    var marker = window.gm_markers[id];
    console.log(marker);

    map.setZoom(14);
    map.panTo(marker.position);
}

function setMapFilters(map){
    var filtered_countries =  window.locations;
    var filtered_types =  window.locations;

    $('.checkbox_country').click(function (e) {
        //filter countries
        filtered_countries = filterCountries(getShowCountries(), window.locations);

        filtered_types = filterTypes(getShowTypes(), filtered_countries);

        locations_filtered = filtered_types;

        clearMarkers();
        setLocationMarkers(locations_filtered, map);

    });

    $('#filter_type input').click(function (e) {
        filtered_types = filterTypes(getShowTypes(), filtered_countries);

        locations_filtered = filtered_types;

        clearMarkers();
        setLocationMarkers(locations_filtered, map);

    });
}

function clearMarkers() {
    for (var i = 0; i < window.gm_markers2.length; i++ ) {
        window.gm_markers2[i].setMap(null);
    }
    window.gm_markers2 = [];
}

/*
 Init showMyLocation
 */
$(function() {
    // $('#my_location').click(function () {
    //     showMyLocation();
    // });
    $('.stores li').click(function (e) {
        //e.preventDefault();

        if($(e.currentTarget).hasClass('active')) {
            if($(e.target).hasClass('toggle-button') )
                $('.stores li').removeClass('active');
        } else {
            $('.stores li').removeClass('active');
            $(e.currentTarget).addClass('active');
            zoomOnMarkerWithID($(e.currentTarget).data('id'));
        }
    });
});

var GeoMarker;
function showMyLocation(map) {
    GeoMarker = new GeolocationMarker();
    GeoMarker.setCircleOptions({fillColor: '#808080'});

    google.maps.event.addListenerOnce(GeoMarker, 'position_changed', function() {
        map.setCenter(this.getPosition());
        map.fitBounds(this.getBounds());
        map.setZoom(12);
    });

    google.maps.event.addListener(GeoMarker, 'geolocation_error', function(e) {
        alert('There was an error obtaining your position. Message: ' + e.message);
    });

    GeoMarker.setMap(map);


    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(function(position) {
    //         var myLatLng = {
    //             lat: position.coords.latitude,
    //             lng: position.coords.longitude
    //         };
    //
    //
    //         var myMarker = new google.maps.Marker({
    //             position: myLatLng,
    //             map: map,
    //             // icon: image
    //         });
    //
    //
    //         map.setCenter(myLatLng);
    //         map.setZoom(10);
    //
    //     });
    // } else{
    //     alert('Your browser does not support geolocation');
    // }


}